export default __webpack_public_path__ + "media/people.c3ea5f41.svg";